import { KnownSource } from '../../../types/Source'

const acceptedAges : Partial<Record<KnownSource, number>> & { default : number } = {
  default: 18
} as const

export const getAcceptedAges = (source?: KnownSource | undefined): number => {
  if (!source) return acceptedAges.default
  const result = source in acceptedAges ? acceptedAges[source] : acceptedAges.default

  return result as number
}
